/**
 * Display names of the partners whose payments are synced back. The API sends
 * a lowercase label (`partners`, `partner` on diagnostics and comparisons) or,
 * on a run, the PartnerType value; both are brand names, never translated.
 */
const PARTNER_NAMES: Record<string, string> = {
  odoo: 'Odoo',
  billit: 'Billit',
  chift_accounting: 'Odoo',
  bill_it: 'Billit'
}

export function paymentSyncPartnerName(
  partner: string | null | undefined
): string {
  if (!partner) {
    return ''
  }

  return PARTNER_NAMES[partner] ?? partner
}

export type PaymentSyncRunCounters = {
  reduced?: number
  total_mismatch?: number
  cancelled_at_partner?: number
  skipped_refund?: number
  rescanned?: number
}

/**
 * Counters added for the Billit sync, listed with their i18n key. A run only
 * shows the ones that moved, so an Odoo run reads as it always did.
 */
const EXTRA_COUNTERS: Array<keyof PaymentSyncRunCounters> = [
  'reduced',
  'total_mismatch',
  'cancelled_at_partner',
  'skipped_refund',
  'rescanned'
]

export function nonZeroExtraCounters(
  run: PaymentSyncRunCounters
): Array<{ key: string; value: number }> {
  return EXTRA_COUNTERS.filter((counter) => (run[counter] ?? 0) > 0).map(
    (counter) => ({
      key: `invoicing.payment_sync_counter_${counter}`,
      value: run[counter] as number
    })
  )
}
